import React, { useState, useEffect } from "react";
import Image from "../../atom/image/index";
import { isMobile, isTablet } from 'react-device-detect';
import { useMediaQuery } from '@material-ui/core';
import './countDownTimer.css';

function calculateTimeLeft({ FundEndDate }) {
    const year = new Date().getFullYear();
    const endDate = new Date(`${FundEndDate}T00:00:00`);
    const difference = endDate - new Date();
    let timeLeft = {};

    if (difference > 0) {
        timeLeft = {
            Days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            Hrs: Math.floor((difference / (1000 * 60 * 60)) % 24),
            Mins: Math.floor((difference / 1000 / 60) % 60),
            Sec: Math.floor((difference / 1000) % 60)
        };
    }

    return timeLeft;
}

const CountDownTimer = (props) => {

    const { investNowClick, callBackClick } = props;
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(props));
    const [countdownFinished, setCountdownFinished] = useState(false);
    const isMobileDevice = useMediaQuery('(max-width:988px)');

    useEffect(() => {
        const id = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(props));
        }, 1000);

        return () => {
            clearTimeout(id);
        };
    });

    const timerComponents = Object.keys(timeLeft).map(interval => {
        if (!timeLeft[interval]) {
            return;
        }

        return (
            <div key={interval} className='countdown-time-hours' >
                <div className='countdown-time'>{timeLeft[interval]}</div>
                <div className='countdown-hours' >{interval}</div>
            </div>
        );
    });

    // let height = isMobileDevice ? (props.heightForStrip ? props.heightForStrip : '18vh') : (props.heightForStrip ? props.heightForStrip : '64px')
    let height = isMobileDevice ? 'auto' : (props.heightForStrip ? props.heightForStrip : '64px')
    return (
        <>
            {isMobileDevice ?
                <>
                    {
                        timerComponents.length ?
                            <div className='container col-12  header-countdown-invest-callback-container' style={{ height: height }}>
                                <div className='container'>
                                    <div className='row countdown-timer-container'>
                                        <Image
                                            image={'prelogin-header/loudspeaker.png'}
                                        />

                                        <span className='countdownnfo'>NFO Live - </span>
                                        <div className='invest-cb-wrapper'>
                                            <div className='invest-cb-container'>
                                                <div onClick={investNowClick} className='header-countdown-invest-now-btn'>
                                                    Invest Now
                                                </div>
                                                {/* <div onClick={callBackClick} className='header-countdown-call-back-btn'>
                                                    Call Back
                                                </div> */}
                                            </div>
                                        </div>

                                        <span className='countdownfund'>{props.fundName} Closes in</span>

                                        <div>
                                            {timerComponents}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </>
                :
                <>
                    {timerComponents.length ?
                        <div className='container col-12  header-countdown-invest-callback-container' style={{ height: height }}>
                            <div className='container'>
                                <div className='row countdown-timer-container'>
                                    <Image
                                        image={'prelogin-header/loudspeaker.png'}
                                    />
                                    <span>
                                        <span className='countdownnfo'>NFO Live - </span>
                                        <span className='countdownfund'>{props.fundName} Closes in</span>
                                    </span>

                                    {/* <div> */}
                                    {timerComponents}
                                    {/* </div> */}

                                    <div className='invest-cb-wrapper'>
                                        <div className='invest-cb-container'>
                                            <div onClick={investNowClick} className='header-countdown-invest-now-btn'>
                                                Invest Now
                                            </div>
                                            {/* <div onClick={callBackClick} className='header-countdown-call-back-btn'>
                                                Call Back
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
                    }
                </>
            }
        </>
    );
}
export default CountDownTimer;
